import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import MenuService from '@/services/CmsServices/MenuService';
import { extractError } from '@/helpers/extractApiError';
import { upseartItem } from '@/helpers/CRUD';
import { updateSimpleMenu } from '../update/updateSlice';

const model = {
    data: [],
    totalItems: 0,
    loading: false,
    error: null,
};

export const getMenuList = createAsyncThunk(
    'menu/getMenuList',
    async (data, { rejectWithValue }) => {
        try {
            const response = await MenuService.getMenuList(data);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const menuListSlice = createSlice({
    name: 'menuList',
    initialState: model,
    reducers: {},
    extraReducers: (builder) => {
        // menu list
        builder.addCase(getMenuList.pending, (state) => {
            state.loading = true;
        }).addCase(getMenuList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.menu_list;
            state.totalItems = action.payload.total;
        }).addCase(getMenuList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Handle updating menu
        builder.addCase(updateSimpleMenu.fulfilled, (state, action) => {
            state.data = upseartItem(state.data, action.payload);
        });
    },
});

export default menuListSlice.reducer;
